function startCountdown() {
  document.querySelectorAll('.promo-time-end').forEach(function(el) {
    let endTime = parseInt(el.getAttribute('data-time'), 10) * 1000;
    let countdownEl = el.querySelector('.promo-countdown');

    function updateTimer() {
      let now = Date.now();
      let distance = endTime - now;

      if (distance <= 0) {
        countdownEl.textContent = "00:00:00";
        clearInterval(timer);
        return;
      }

      let hours = Math.floor(distance / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownEl.textContent =
        String(hours).padStart(2, '0') + ":" +
        String(minutes).padStart(2, '0') + ":" +
        String(seconds).padStart(2, '0');
    }

    let timer = setInterval(updateTimer, 1000);
    updateTimer();
  });
}


(function ($) {

  window.checkPrice = function() {
    $('.price__container').each(function() {
      const $container = $(this);
      const promoDiscount = $container.attr('data-promo-discount');
      const bannerPrice = $container.closest('.pdp-sticky-banner__price');

      if(!$(bannerPrice).length && !!promoDiscount) {
        $container.find('.new-price').remove();

        const $priceItem = $container.find('.price__regular .price-item');
        let priceText = $priceItem.text().trim();
        if (!priceText) return;

        const matchPrefixFrom = priceText.match(/^(from)\s+/i);
        // Remembered on the container: the first run strips "From" from the price, so re-runs (sticky banner, recommendations) can't see it anymore.
        let wordPrefix = $container.attr('data-price-from') || '';

        if (matchPrefixFrom) {
          wordPrefix = matchPrefixFrom[1] + ' ';
          $container.attr('data-price-from', wordPrefix);
          priceText = priceText.replace(/^(from)\s+/i, '');
          $priceItem.text(priceText);
        }

        // Preferred: already formatted by Shopify in Liquid (snippets/promo-price.liquid) — parsing below breaks on "739 000 UZS", "Dhs. 226.00 AED".
        const promoPrice = $container.attr('data-promo-price');
        if (promoPrice) {
          $('<div class="new-price" />').text($('<div />').html(promoPrice).text().trim()).appendTo($container);
          $container.addClass('has-new-price');
          return;
        }

        let prefix = (priceText.match(/^([^\d]+)/) || ['',''])[1].trim();
        const suffix = (priceText.match(/([^\d]+)$/) || ['',''])[1].trim();

        const currencySymbols = /[₴$€£¥₽₹₩₦₫₲₺₡₢₣₤₧₨₪₭₮₱₲₳₵₸₼₾₿]/;
        if (prefix && !currencySymbols.test(prefix)) {
          prefix = prefix + ' ';
        }

        const numericPart = (priceText.match(/[\d.,]+/) || [''])[0];
        if (!numericPart) return;

        const normalized = normalizeNumberString(numericPart);
        const value = parseFloat(normalized);
        if (isNaN(value)) return;

        // Shopify's rule: % off in cents, fractional cent dropped (24.99 at 20% → 20.00, not 19.99).
        const cents = Math.round(value * 100);
        const discounted = (cents - Math.floor(cents * parseFloat(promoDiscount) / 100)) / 100;

        const decimalsMatch = numericPart.match(/([.,])(\d+)$/);
        const decimals = decimalsMatch ? decimalsMatch[2].length : 0;

        const decimalSep = detectDecimalSeparator(numericPart);
        const locale = decimalSep === ',' ? 'de-DE' : 'en-US';
        const formatted = (decimals > 0 && (discounted % 1 !== 0))
          ? discounted.toLocaleString(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
          : Math.round(discounted).toLocaleString(locale);

        const resultText = `${wordPrefix}${prefix}${formatted}${suffix ? ' ' + suffix : ''}`.trim();

        $('<div class="new-price" />').text(resultText).appendTo($container);

        $container.addClass('has-new-price');

        // console.log('orig:', priceText, '→ numericPart:', numericPart, '→ value:', value, '→ discounted:', discounted, '→ formatted:', resultText);
      }
    });

    updatePromoPriceLabels();
  };

  // PDP label under the price: % of the variant whose price is currently rendered; hidden when it has none.
  function updatePromoPriceLabels() {
    $('.product__promo-price-label').each(function() {
      const $label = $(this);
      const discount = $('#' + $label.attr('data-price-id') + ' .price__container').attr('data-promo-discount');
      if (discount) {
        $label.find('.product__promo-price-label__text').text($label.attr('data-template').replace('${}', discount));
      }
      $label.toggleClass('m-hidden', !discount);
    });
  }

  function normalizeNumberString(s) {
    s = (s || '').trim();
    if (!s) return '';
    const hasDot = s.indexOf('.') !== -1;
    const hasComma = s.indexOf(',') !== -1;

    if (hasDot && hasComma) {
      if (s.lastIndexOf('.') > s.lastIndexOf(',')) {
        return s.replace(/,/g, '');
      } else {
        return s.replace(/\./g, '').replace(',', '.');
      }
    }

    if (hasComma) {
      const parts = s.split(',');
      if (parts[1] && parts[1].length <= 2) return s.replace(',', '.');
      return s.replace(/,/g, '');
    }

    if (hasDot) {
      const parts = s.split('.');
      if (parts[1] && parts[1].length <= 2) return s;
      return s.replace(/\./g, '');
    }

    return s;
  }

  function detectDecimalSeparator(s) {
    if (!s) return '.';
    const hasDot = s.indexOf('.') !== -1;
    const hasComma = s.indexOf(',') !== -1;
    if (hasDot && hasComma) return s.lastIndexOf('.') > s.lastIndexOf(',') ? '.' : ',';
    if (hasComma) {
      const p = s.split(',');
      return (p[1] && p[1].length <= 2) ? ',' : '.';
    }
    if (hasDot) {
      const p = s.split('.');
      return (p[1] && p[1].length <= 2) ? '.' : ',';
    }
    return '.';
  }


  $(document).ready(function () {
    if ($('.promo-running-line').length) {
      $('.promo-running-line__slider')
        .on('beforeStarting', function() {
          $(this).closest('.promo-running-line').addClass('m-run');
        })
        .marquee({
          speed: 20,
          direction: 'left',
          startVisible: true,
          pauseOnHover: false,
          duplicated: true
        });
    }

    if ($('.promo-time-end').length) {
      startCountdown();
    }

    if ($('.price__container').length) {
      window.checkPrice();
    }

    // The price gets re-rendered on variant change (Dawn, photobook options); the label lives outside it, so re-read on each change.
    $('.product__promo-price-label').each(function() {
      const priceEl = document.getElementById($(this).attr('data-price-id'));
      if (priceEl) new MutationObserver(updatePromoPriceLabels).observe(priceEl, { childList: true, subtree: true });
    });

    if($('product-recommendations').length) {
      let trigger = 0;
      function checkRecommendations() {
        if(trigger < 20) {
          if($('product-recommendations .price__container').length) {
            window.checkPrice();
          } else {
            trigger++
            setTimeout(function() {
              checkRecommendations();
            },1000);
          }
        }
      }
      checkRecommendations();
    }

    if($('.product__promo-block').length) {
      if($('.product__promo-block').next().hasClass('product__text')) {
        $('.product__promo-block').insertAfter($('.product__promo-block').next());
        $('.product__promo-block').removeClass('m-hidden');
      } else {
        $('.product__promo-block').removeClass('m-hidden');
      }
    }
  });
})(jQuery);
